import { useLang } from '@/i18n';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import EfCardRecommend from '@elem/ui/ef-card-recommend';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('theProduct.Bundles');
    const btnText1 = t('btn_text1');
    const btnText2 = t('btn_text2');
    const variantIdA = '44505650528417';
    const variantIdB = '44505652854945';
    const itemA: any = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723030469186/a1.png',
        label: t('a_label'),
        title: t('a_title'),
        price: 111750,
        compareAtPrice: 222222,
        buyText: btnText2,
        variantId: variantIdA,
        moreLink: 'https://jp.ecoflow.com/products/river-3-60w-solar-panel-bundle',
        moreText: btnText1,
    };
    const itemB: any = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723030469356/a2.png',
        label: t('b_label'),
        title: t('b_title'),
        price: 111750,
        compareAtPrice: 222222,
        buyText: btnText2,
        moreLink: 'https://jp.ecoflow.com/products/river-3-45w-solar-panel-bundle',
        moreText: btnText1,
        variantId: variantIdB,
    };
    const [listA, setListA] = useState([itemA, itemB]);

    useEffect(() => {
        const variantIds = [variantIdA, variantIdB];
        const initAll = async () => {
            const res = await getSolarRecommand2({ variantIds }, locale);
            if (res.code === '0') {
                const data = res.data || [];
                //第1个产品
                const itemA2 = data.find((item: any) => {
                    return item.variantId === variantIdA;
                });
                if (itemA2) {
                    itemA.title = itemA2.productTitle;
                    itemA.price = itemA2.price;
                    itemA.compareAtPrice = itemA2.compareAtPrice;
                    itemA.pc = itemA2.img;
                }
                //第2个产品
                const itemB2 = data.find((item: any) => {
                    return item.variantId === variantIdB;
                });
                if (itemB2) {
                    itemB.title = itemB2.productTitle;
                    itemB.price = itemB2.price;
                    itemB.compareAtPrice = itemB2.compareAtPrice;
                    itemB.pc = itemB2.img;
                }

                setListA([itemA, itemB]);
            }
        };
        initAll();
    }, []);

    return (
        <div className={styles.BundlesCommon3}>
            <EfSpec />
            <div className="ef-container ListC-in">
                {listA.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfCardRecommend {...item} />
                        </Fragment>
                    );
                })}
            </div>
            <EfSpec />
        </div>
    );
}
